export default __webpack_public_path__ + "static/media/cryptoTracker.3b3db99a.jpg";